import React from 'react';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@emotion/react';
import { InboundProvider } from './context/InboundContext';
import App from './App';
import theme from './constants/theme';
import 'react-toastify/dist/ReactToastify.css';
import './styles/global.css';
import './tailwind.css';

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  enabled: import.meta.env.VITE_APP_SARAL_ENV === 'prod',
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <InboundProvider>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={1200}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover={false}
            theme="colored"
          />
        </InboundProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
